<div *ngIf="loadingspinner == true" class="spin"></div>
<fieldset [disabled]="loadingspinner == true" [ngClass]="{'disabled':loadingspinner == true}">

  <div class="d-flex flex-wrap" *ngIf="token">
    <div class="two-card common-padding pay-money shadow">
      <button class="btn btn-primary" style="float: right;" (click)="Back()">Back</button>
      &nbsp;
      <h2 class="heading">View Payment Request</h2>
      <div class="row no-gutters">
        <div class="col-12">
          <div class="row no-gutters">
            <div class="col-md-12">
              <div class="add-balance">
                <div class="ctl-inner">
                  <span class="crtl icon-add_money_1"></span>
                </div>
                <div>
                  <span class="bal-txt">Balance</span>
                  <span class="bal_amount">{{UsertBal.currentBalance}} {{UsertBal.currency}}</span>
                </div>
              </div>
            </div>

            <div class="col-md-12 form-padding">
              <p *ngIf="total_count===0">
                <strong>Sorry!</strong> No record found!.
              </p>

              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">User Detail</th>
                    <th scope="col">Comment	</th>
                    <th scope="col">Reference Id	</th>
                    <th scope="col">User Request Date	</th>
                    <th scope="col">Request Amount</th>
                  </tr>
                </thead>
                <tbody>

                  <tr *ngFor="let pr of transactionList">
                    <td>
                      <h6>{{pr.details}}</h6>

                    </td>
                    <td>{{pr.comments}}</td>
                    <td>{{pr.ezipayRefrenceid}}</td>
                    <td>

                      <h6>{{pr.transactionDate|date}}</h6>
                    </td>
                    <td>
                      <p>Amount : {{pr.amount}}</p>
                      <p>Fee :  {{pr.fee}}</p>
                      <p>Net payable : {{pr.totalAmount}}</p>
                      <!--<button class="btn btn-danger mr-3" (click)="manageTransactionsRequest(pr.ezipayRefrenceid,0)">Reject</button>
  <button class="btn btn-success" (click)="manageTransactionsRequest(pr.ezipayRefrenceid,1)">Pay Now</button>-->
                      <button class="btn btn-danger mr-3" (click)="openPasswordDialog(pr.ezipayRefrenceid,0)">Reject</button>
                      <button class="btn btn-success" (click)="openPasswordDialog(pr.ezipayRefrenceid,1)">Pay Now</button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="pagenation-wrapper" *ngIf="total_count>0">
                <mat-paginator [length]="total_count" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                               (page)="handle($event)">
                </mat-paginator>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>



</fieldset>


